var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { flex: "1" } },
    [
      _c(
        "div",
        { staticClass: "tls-application-center" },
        [
          _vm.applicationCenterCMSModels.length > 1
            ? _c("div", [
                _c("header", { staticClass: "tls-simple-banner" }, [
                  _c("div", { staticClass: "tls-home-text-group" }, [
                    _c("h1", { staticClass: "tls-heading-1" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm._.get(
                              _vm.residenceCountryCMSData,
                              "welcome_header"
                            )
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tls-simple-text -color-white -size-18" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._.get(
                                _vm.residenceCountryCMSData,
                                "welcome_content"
                              )
                            ) +
                            "\n                            "
                        ),
                        _c("img", {
                          staticClass: "tls-image",
                          attrs: {
                            src: _vm._.get(
                              _vm.residenceCountryCMSData,
                              "countryFlag.data.full_url"
                            ),
                            alt: "Country flag"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tls-application-center--content" }, [
                  _c(
                    "div",
                    { staticClass: "tls-application-center--heading" },
                    [
                      _c("h2", { staticClass: "tls-heading-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm._.get(
                              _vm.residenceCountryCMSData,
                              "splash_header"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-application-center--info" }, [
                    _c("div", {
                      directives: [
                        {
                          name: "dompurify-html",
                          rawName: "v-dompurify-html",
                          value: _vm._.get(_vm.splashCMSData, "splash_content"),
                          expression: "_.get(splashCMSData,'splash_content')"
                        }
                      ],
                      staticClass: "tls-simple-text -size-16 -style-italic",
                      style: {
                        color: _vm._.get(
                          _vm.splashCMSData,
                          "splash_content_color"
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tls-button-image-group" },
                    _vm._l(_vm.applicationCenterCMSModels, function(
                      applicationCenter
                    ) {
                      return _c(
                        "div",
                        {
                          key: _vm._.get(applicationCenter, "code"),
                          staticClass: "tls-button-image-group--slot"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tls-button-image-group--button",
                              on: {
                                click: function($event) {
                                  _vm.chooseApplicationCenter(
                                    _vm._.get(_vm.countryCMSData, "name"),
                                    applicationCenter
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "tls-button-image",
                                  attrs: {
                                    to: {
                                      name: "ApplicationCenterHome",
                                      params: {
                                        residenceCountryCode:
                                          _vm.residenceCountryCode,
                                        issuer: _vm._.get(
                                          applicationCenter,
                                          "code"
                                        )
                                      }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tls-button-image--decoration"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tls-decoration-vertical-lines -white"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "tls-line1"
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "tls-line2"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tls-button-image--img",
                                      style: {
                                        backgroundImage:
                                          "url(" +
                                          _vm._.get(
                                            applicationCenter,
                                            "background.data.url"
                                          ) +
                                          ")"
                                      },
                                      attrs: {
                                        "data-tls-value":
                                          "thumbnail-applicationcenter"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tls-button-image--content"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tls-simple-text tls-simple-texts -color-white -size-40"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      applicationCenter,
                                                      "name_translation"
                                                    )
                                                  ) +
                                                  "\n                                                "
                                              ),
                                              _c("br"),
                                              _vm._v(" "),
                                              applicationCenter.temporary_closed
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "margin-top10"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    (" +
                                                          _vm._s(
                                                            _vm._.get(
                                                              _vm.keywords,
                                                              "temporary_closed_notification"
                                                            )
                                                          ) +
                                                          ")\n                                                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tls-button-image--content-small-text"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tls-text-underline"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-text-underline--text"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tls-simple-text -color-white -size-16"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "applierApplicationCenter.selectCenterTip"
                                                                )
                                                              ) +
                                                              "\n                                                        "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-text-underline--decoration"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tls-decoration-horizontal-lines"
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "tls-line1"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "tls-line2"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.countryAvsCMSData.length > 0
                    ? _c(
                        "div",
                        { staticClass: "tls-application-center--avs" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tls-application-center-avs--heading"
                            },
                            [
                              _c("h2", { staticClass: "tls-heading-2" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.$t("multiplePage.recommendedServices")
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tls-application-center-avs--content"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tls-card-info-list" },
                                _vm._l(_vm.countryAvsCMSData, function(
                                  countryAvs
                                ) {
                                  return _c(
                                    "div",
                                    { staticClass: "tls-card-info-list--item" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tls-card-info" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tls-card-info--img"
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "tls-card-info--icon",
                                                attrs: {
                                                  alt: _vm._.get(
                                                    countryAvs,
                                                    "name"
                                                  ),
                                                  src: _vm._.get(
                                                    countryAvs,
                                                    "avs.image_url"
                                                  )
                                                    ? _vm._.get(
                                                        countryAvs,
                                                        "avs.image_url"
                                                      )
                                                    : _vm._.get(
                                                        countryAvs,
                                                        "avs.image.data.url"
                                                      )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tls-card-info--content"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tls-simple-text -color-main -weight-bold -size-16"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm._.get(
                                                          countryAvs,
                                                          "name"
                                                        )
                                                          ? _vm._.get(
                                                              countryAvs,
                                                              "name"
                                                            )
                                                          : _vm._.get(
                                                              countryAvs,
                                                              "avs.name"
                                                            )
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._.get(countryAvs, "price") >
                                                0 &&
                                              _vm._.get(
                                                countryAvs,
                                                "currency.code"
                                              ) !== _vm.onDemand
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-simple-text -weight-bold -size-16"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm._.get(
                                                              countryAvs,
                                                              "price"
                                                            )
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm._.get(
                                                              countryAvs,
                                                              "currency.name"
                                                            )
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-simple-text -weight-bold -size-16"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            _vm._.get(
                                                              _vm.onDemandCurrency,
                                                              "name"
                                                            )
                                                              ? _vm._.get(
                                                                  _vm.onDemandCurrency,
                                                                  "name"
                                                                )
                                                              : _vm.onDemand
                                                          ) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tls-card-info--content-paragraph"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-simple-text -size-16"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm._.get(
                                                              countryAvs,
                                                              "short_description"
                                                            )
                                                              ? _vm._.get(
                                                                  countryAvs,
                                                                  "short_description"
                                                                )
                                                              : _vm._.get(
                                                                  countryAvs,
                                                                  "avs.short_description"
                                                                )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tls-card-info--content-button"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "tls-button-dynamic",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onAVSMoreInfoClick(
                                                            countryAvs
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "tls-button-dynamic--text"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "tls-simple-text -color-primary -size-19"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "multiplePage.moreInfomation"
                                                                    )
                                                                  ) +
                                                                  "\n                                                        "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._m(0, true)
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._.get(
                    _vm.splashCMSData,
                    "available_appointment_table_power_switch"
                  )
                    ? _c(
                        "div",
                        { staticClass: "tls-application-center--rdv" },
                        [
                          _c(
                            "div",
                            { staticClass: "tls-application-center--heading" },
                            [
                              _c("h2", { staticClass: "tls-heading-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._.get(_vm.splashCMSData, "table_header")
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tls-application-center--info" },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "dompurify-html",
                                    rawName: "v-dompurify-html",
                                    value: _vm._.get(
                                      _vm.splashCMSData,
                                      "table_info"
                                    ),
                                    expression:
                                      "_.get(splashCMSData,'table_info')"
                                  }
                                ]
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-tab-content-paragraph" }, [
                    _c(
                      "a",
                      {
                        staticClass: "tls-link",
                        attrs: { href: _vm._.get(_vm.path, "path") + "#top" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-chevron-up" }),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm._.get(_vm.keywords, "back_to_the_top"))
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.splashCarousel, "carousel")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel -pc",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(_vm._.get(_vm.splashCarousel, "carousel"), function(
                  carousel
                ) {
                  return _c(
                    "swiper-slide",
                    {
                      key: _vm._.get(carousel, "img_link"),
                      staticClass: "swiper-slide"
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm._.get(carousel, "link") } },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._.get(carousel, "img_link"),
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.splashCarousel, "carousel_mobile")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel -mobile",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(
                  _vm._.get(_vm.splashCarousel, "carousel_mobile"),
                  function(carousel) {
                    return _c(
                      "swiper-slide",
                      {
                        key: _vm._.get(carousel, "img_link"),
                        staticClass: "swiper-slide"
                      },
                      [
                        _c(
                          "a",
                          { attrs: { href: _vm._.get(carousel, "link") } },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm._.get(carousel, "img_link"),
                                alt: ""
                              }
                            })
                          ]
                        )
                      ]
                    )
                  }
                ),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-title": _vm._.get(_vm.moreAvsInfoData, "name")
                ? _vm._.get(_vm.moreAvsInfoData, "name")
                : _vm._.get(_vm.moreAvsInfoData, "avs.name"),
              "popup-data": {
                simpleText: _vm._.get(_vm.moreAvsInfoData, "long_description")
                  ? _vm._.get(_vm.moreAvsInfoData, "long_description")
                  : _vm._.get(_vm.moreAvsInfoData, "avs.long_description"),
                videoLink: _vm._.get(_vm.moreAvsInfoData, "video_url")
                  ? _vm._.get(_vm.moreAvsInfoData, "video_url")
                  : _vm._.get(_vm.moreAvsInfoData, "avs.video_url")
              },
              hasConfirmAction: false,
              hasCancelAction: false
            },
            on: { "close-action": _vm.closeAvsPopup }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-button-dynamic--decoration" }, [
      _c("div", { staticClass: "tls-line1" }),
      _vm._v(" "),
      _c("div", { staticClass: "tls-line2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }